import { FC } from 'react';
import { PageTitle, PageLink } from '../../../../rbts/layout/core';
import { View } from './components/View';

const TraspasosPage: FC = () => {
  const breadcrumbs: Array<PageLink> = [];

  return (
    <>
      <PageTitle breadcrumbs={breadcrumbs}>Traspaso Wallet → Folio Físico</PageTitle>
      <View />
    </>
  );
};

export { TraspasosPage };
export default TraspasosPage;
